var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnipayLogoNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1564_47869)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1564_47869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8613 40H7.13868C3.19716 40 0 36.8028 0 32.8613V7.13868C0 3.19716 3.19716 0 7.13868 0H32.8613C36.8028 0 40 3.19716 40 7.13868V32.8613C40 36.8028 36.8028 40 32.8613 40Z",
    fill: "#006770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2105 27.8033C25.3647 32.8897 18.1232 33.8928 13.0404 30.047C7.95396 26.2012 6.95086 18.9597 10.7967 13.8768C13.8485 9.84316 19.1689 8.26585 23.9221 9.98494L25.6979 7.6491L25.7191 7.62074C26.6017 8.00355 27.4418 8.47143 28.2287 9.02438L28.2074 9.05273L26.4989 11.3141L24.7728 13.5826L23.0607 15.8476L23.0395 15.8759L16.0497 25.1449L16.0284 25.1732C15.2663 24.4785 14.6992 23.5959 14.3944 22.6106L14.4192 22.5751L20.1259 15.0146L20.1507 14.9792L22.0966 12.4023C21.4125 12.2322 20.7107 12.1436 20.0054 12.1436C19.5977 12.1436 19.1937 12.1719 18.7896 12.2286C14.0364 12.8985 10.7293 17.2938 11.3992 22.0434C12.0692 26.7966 16.4644 30.1037 21.214 29.4338C25.9673 28.7639 29.2743 24.3686 28.6044 19.619C28.4626 18.5981 28.1365 17.6128 27.6474 16.7054L25.6589 19.339L25.6305 19.3744L20.1046 26.6832L20.0763 26.7187H19.9664C18.9562 26.7187 17.9602 26.4599 17.0811 25.9566L17.1024 25.9282L24.0709 16.6983L24.0922 16.6699L25.8078 14.3943L27.541 12.0975L29.2495 9.83607L29.2708 9.80417C30.008 10.4245 30.6815 11.1192 31.2805 11.8742L31.2592 11.9025L29.4834 14.2526C32.3155 18.3571 32.2021 23.8121 29.1999 27.7927V27.7997L29.2105 27.8033Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1564_47869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1564_47869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnipayLogoNav);
export default __webpack_public_path__ + "static/media/earnipay-logo-nav.951060600cf071dbd74cd7c729078bc0.svg";
export { ForwardRef as ReactComponent };